module.exports = __webpack_public_path__ + "img/classes_default.90a5d5ad.png";